import { DeviceType } from '@/src/types/deviceType'
import { ItineraryStepNumberType } from '@/src/types/itinerary'
import { Avatar, Box, Typography } from '@mui/material'

interface HeaderBlockProps {
    step: ItineraryStepNumberType
    isStepCompleted: boolean
    isStepActive: boolean
    stepTitle: string
    deviceType?: DeviceType
}

const HeaderBlock = ({ step, isStepCompleted, isStepActive, stepTitle, deviceType }: HeaderBlockProps) => {
    const isMobile = deviceType === 'MOBILE'

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: {
                    xs: 1,
                    md: 2
                },
                px: {
                    xs: 1,
                    md: 0
                },
                py: {
                    xs: 0.5,
                    md: 1
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: {
                        xs: 0.5,
                        md: 1
                    }
                }}
            >
                {!isMobile && (
                    <Avatar
                        sx={{
                            width: 32,
                            height: 32,
                            bgcolor: isStepActive
                                ? 'neutral.black'
                                : isStepCompleted
                                  ? 'primary.main'
                                  : 'neutral.white',
                            color: isStepActive || isStepCompleted ? 'neutral.white' : 'neutral.black',
                            borderColor: isStepCompleted ? 'primary.main' : 'neutral.black',
                            fontSize: 14,
                            fontWeight: 'bold',
                            border: '2px solid'
                        }}
                    >
                        {step}
                    </Avatar>
                )}
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 'bold',
                        fontSize: {
                            xs: 16,
                            md: 18
                        },
                        lineHeight: {
                            xs: 1.2,
                            md: 1.4
                        }
                    }}
                >
                    {stepTitle}
                </Typography>
            </Box>
        </Box>
    )
}

export default HeaderBlock
